import { render, staticRenderFns } from "./OnboardingModeration.vue?vue&type=template&id=b8197e02&scoped=true"
import script from "./OnboardingModeration.vue?vue&type=script&lang=js"
export * from "./OnboardingModeration.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./OnboardingModeration.vue?vue&type=style&index=1&id=b8197e02&prod&scoped=true&lang=css"
import style2 from "./OnboardingModeration.vue?vue&type=style&index=2&id=b8197e02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8197e02",
  null
  
)

export default component.exports